define('taoQtiItem/qtiXmlRenderer/renderers/choices/InlineChoice',['tpl!taoQtiItem/qtiXmlRenderer/tpl/element'], function(tpl){
    return {
        qtiClass : 'inlineChoice',
        template : tpl
    };
});
